import React, { useEffect, useState } from 'react';
import { StatusFormSetting } from '../AssetTabs';
import '../../../AssetStatusForm.scss'

interface FieldState {
  [key: string]: string;
}

type SetPageFunction = React.Dispatch<React.SetStateAction<{ [key: string]: FieldState; }>>;
type SetTabPageFunction = React.Dispatch<React.SetStateAction<string>>
type SetChangeFieldFunction = React.Dispatch<React.SetStateAction<{
  [formName: string]: Set<string>;
}>>

interface IoConfigFormProps {
  formState: { [key: string]: FieldState };
  setFormState: SetPageFunction;
  setTabDivHeight: SetTabPageFunction;
  IoConfigFormData: StatusFormSetting[] | undefined;
  changedFields: { [formName: string]: Set<string> };
  setChangedFields: SetChangeFieldFunction;
  formNames: string;
  isToggle: boolean;
}

interface InitialValues {
  [formName: string]: {
    [fieldName: string]: string;
  };
}

const IoConfigForm: React.FC<IoConfigFormProps> = ({ formState, setFormState, setTabDivHeight, IoConfigFormData, changedFields, setChangedFields, formNames, isToggle }) => {
  const [initialValues, setInitialValues] = useState<{ [formName: string]: { [fieldName: string]: string } }>({});
  const FormName = formNames

  useEffect(() => {
    setTabDivHeight("1250px");
  }, []);
  useEffect(() => {
    // Initialize initial values when the component mounts or when form data is initialized
    const initialValues: InitialValues = {};
    // Initialize initial values for each form and field
    // Assuming formState has been initialized with initial form data
    Object.keys(formState).forEach(formName => {
      initialValues[formName] = {};
      Object.keys(formState[formName]).forEach(fieldName => {
        initialValues[formName][fieldName] = formState[formName][fieldName];
      });
    });
    setInitialValues(initialValues);
    setChangedFields({})
  }, [FormName, isToggle]);

  // Handle input change for a specific field in a specific form
  const handleInputChange = (formName: string, fieldName: string, value: string) => {
    setFormState((prevFormState) => ({
      ...prevFormState,
      [formName]: {
        ...prevFormState[formName],
        [fieldName]: value,
      },
    }));

    // setChangedFields((prevChangedFields) => ({
    //   ...prevChangedFields,
    //   [formName]: new Set<string>([...(prevChangedFields[formName] || []), fieldName]),
    // }));
  };

  // Function to identify change in field value
  const handleFieldChange = (formName: string, fieldName: string, newValue: string) => {
    const initialValue = initialValues[formName]?.[fieldName];
    if (initialValue !== newValue) {
      setChangedFields((prevChangedFields) => ({
        ...prevChangedFields,
        [formName]: new Set<string>([...(prevChangedFields[formName] || []), fieldName]),
      }));
    } else if (initialValue === newValue) {
      setChangedFields((prevChangedFields) => {
        const updatedFields = new Set<string>(prevChangedFields[formName] || []);
        updatedFields.delete(fieldName); // Remove the field name if the value reverts back to the initial value
        return {
          ...prevChangedFields,
          [formName]: updatedFields,
        };
      });
    }
  };


  return (
    <div style={{ paddingLeft: "15px" }}>
      {/* IOConfig Form */}
      <div style={{ display: 'flex', flexDirection: 'row', columnGap: '20px', rowGap: "10px", flexWrap: 'wrap' }}>
        {IoConfigFormData?.map(({ id, value, name, label, type, options, enable, description, unit }) => (
          <div key={id} style={{ flexBasis: '18%' }}>
            {enable && (
              <div className="tooltip-container">
                <label
                  style={{ display: 'block', marginBottom: '2px', marginLeft: "3px" }}
                >
                  {label}
                </label>
                {description && <span className="tooltip-text">{description}</span>}
              </div>
            )}
            {type !== "dropdown" ?
              <div className="relative w-full">
                {/* Background fake text with unit */}
                <div
                  className="absolute top-0 left-0 w-full h-full pointer-events-none flex items-center justify-end pr-2"
                  style={{
                    color: "var(--Primary-Indigo-500, #0094BD)",
                    fontSize: "18px",
                    padding: "6px",
                    borderRadius: "8px",
                    textAlign: "right",
                  }}
                >
                  {unit ? `| ${unit}` : ""}
                </div>
                <input
                  type={"number"}
                  value={formState[FormName] ? formState[FormName][name] : value}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    handleInputChange(FormName, name, newValue);
                    handleFieldChange(FormName, name, newValue);
                  }}
                  style={{ visibility: enable ? "visible" : "hidden", padding: "6px", color: 'white', borderRadius: '8px', textAlign: 'right', backgroundColor: changedFields[FormName]?.has(name) ? "rgb(208 196 64)" : "rgb(5 17 35)", width: "105%",paddingRight: unit ? "5.5rem" : "6px" }}
                  placeholder={label}
                />
              </div> : <select
                value={formState[FormName] ? formState[FormName][name] : value}
                onChange={(e) => {
                  const newValue = e.target.value;
                  handleInputChange(FormName, name, newValue);
                  handleFieldChange(FormName, name, newValue);
                }}
                style={{ visibility: enable ? "visible" : "hidden", padding: "6px", color: 'white', borderRadius: '8px', textAlign: 'left', backgroundColor: changedFields[FormName]?.has(name) ? "rgb(208 196 64)" : "rgb(5 17 35)", width: "105%" }}
              >
                {options?.map((option: any) => (
                  <option key={option.value} value={option.value}>
                    {option.text}
                  </option>
                ))}
              </select>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default IoConfigForm;
